import { useState, useContext } from "react";
import { AppContext } from "../components/desktop/AppProviderDesktop";


export default function Converter ({num}) {
    const [Hover, setHover] = useState(false);

    const {dollarGate} = useContext(AppContext);

    function enter(event) {
        event.preventDefault();
        setHover(true);
    }

    return (
        <p className="converter" onMouseEnter={enter} onMouseLeave={() => setHover(false)}> 
            {`${Hover ? Math.round(num * dollarGate) : num}${Hover ? '₪': '$'}`} 
        </p>
    )
}